import React from 'react'
import { StyledNotFound } from './NotFound.styled'
export default function NotFound() {
return (
 <StyledNotFound> 
     <h1><b>404</b> page not found</h1>
 </StyledNotFound> 
)
}
